import React, { Component } from 'react';
import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import classNames from 'classnames';

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var expand = function expand(props) {
  return /* @__PURE__ */React.createElement("svg", __spreadValues({
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /* @__PURE__ */React.createElement("path", {
    d: "M15.071 8.371V4.585l-4.355 4.356a.2.2 0 0 1-.283 0l-.374-.374a.2.2 0 0 1 0-.283l4.356-4.355h-3.786a.2.2 0 0 1-.2-.2V3.2c0-.11.09-.2.2-.2H16v5.371a.2.2 0 0 1-.2.2h-.529a.2.2 0 0 1-.2-.2zm-6.5 6.9v.529a.2.2 0 0 1-.2.2H3v-5.371c0-.11.09-.2.2-.2h.529c.11 0 .2.09.2.2v3.786l4.355-4.356a.2.2 0 0 1 .283 0l.374.374a.2.2 0 0 1 0 .283L4.585 15.07h3.786c.11 0 .2.09.2.2z",
    fill: "#000",
    fillRule: "nonzero"
  }));
};

var styles$1 = {"fontElementMap":"wgnA0","inPluginInput":"gswUK"};

var InPluginInput = /*#__PURE__*/function (_Component) {
  _inheritsLoose(InPluginInput, _Component);
  function InPluginInput() {
    var _this;
    _this = _Component.apply(this, arguments) || this;
    _this.handleFocus = function (e) {
      e.stopPropagation();
      _this.props.setFocusToBlock();
      _this.props.setInPluginEditingMode(true);
    };
    _this.handleBlur = function () {
      return _this.props.setInPluginEditingMode(false);
    };
    _this.handleKeyPress = function (e) {
      var _this$props = _this.props,
        setFocusToBlock = _this$props.setFocusToBlock,
        value = _this$props.value;
      if (e.key === "Enter" && setFocusToBlock && value !== "") {
        _this.handleBlur();
        setFocusToBlock();
      }
    };
    _this.onChange = function (e) {
      var _a, _b;
      return (_b = (_a = _this.props).onChange) == null ? void 0 : _b.call(_a, e.target.value);
    };
    return _this;
  }
  var _proto = InPluginInput.prototype;
  _proto.render = function render() {
    var className = classNames(styles$1.inPluginInput, this.props.className);
    return /* @__PURE__ */React.createElement("textarea", {
      className: className,
      value: this.props.value,
      onChange: this.onChange,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onKeyPress: this.handleKeyPress,
      dir: "auto",
      rows: 1
    });
  };
  return InPluginInput;
}(Component);
InPluginInput.defaultProps = {
  setInPluginEditingMode: function setInPluginEditingMode() {
    return false;
  },
  setFocusToBlock: function setFocusToBlock() {
    return false;
  }
};

var styles = {"fontElementMap":"JhrXW","imageContainer":"Q6a5A","expandContainer":"PiI7v","expandIcon":"Nh3F1","pointer":"XHhj0","imageWrapper":"vBPBf","imageRatio":"L9OMM","image":"wfdG8","imageOverlay":"FuYgP","imageCaption":"zoci8","imagePreload":"EBiai","imageHighres":"IFfEr","onlyHighRes":"iAg93","image_loading":"HKB9t"};

export { InPluginInput as I, expand as e, styles as s };
